import React from 'react';
import { Icon } from '../../../Icons/Icon';
import { formatDateToDisplayShortLocalMonth } from '../../../utils/utils';
import { TransactionData } from '../utils/transactionUtils';
import { getStatusColor } from '../utils/statusUtils';
import { getTransactionTypeBadge } from '../utils/transactionTypeUtils';

interface TransactionListItemProps {
  transaction: TransactionData;
  isSelected: boolean;
  onClick: () => void;
}

export const TransactionListItem: React.FC<TransactionListItemProps> = ({
  transaction,
  isSelected,
  onClick,
}) => {
  const typeBadge = getTransactionTypeBadge(transaction);

  return (
    <div
      className={`flex px-[30px] py-[24px] items-center border-b border-[#DEE2EF] cursor-pointer hover:bg-[#F5F7FA] ${
        isSelected ? 'bg-[#F5F7FA]' : ''
      }`}
      onClick={onClick}
    >
      <div className='flex justify-between w-full'>
        <div className='flex max-w-[50%] flex-col gap-4 items-start'>
          <span
            className={`text-base break-words whitespace-normal max-w-full ${
              isSelected ? 'text-main font-bold' : 'text-light/80 font-medium'
            }`}
          >
            {transaction.buildingName || 'Unknown Building'}
          </span>
          <div className='flex flex-col gap-1'>
            <span className={`text-base font-bold ${getStatusColor(transaction.status)}`}>
              ${Number(transaction.totalAmount).toLocaleString('en-US')}
            </span>
            <span
              className={`text-sm ${
                isSelected ? 'text-light/90 font-bold' : 'text-light/50 font-medium'
              }`}
            >
              {formatDateToDisplayShortLocalMonth(transaction.date)}
            </span>
          </div>
        </div>

        <div className='flex flex-col justify-center gap-2 items-end'>
          {typeBadge && (
            <div className={`flex px-2 py-[6px] justify-center items-center rounded-[30px] ${typeBadge.bgColor}`}>
              <span className={`${typeBadge.textColor} font-bold text-xs`}>{typeBadge.label}</span>
            </div>
          )}
          {transaction?.paymentType === 'subscription' && (
            <div className='flex px-2 py-[6px] justify-center items-start gap-4 rounded-[30px] bg-[rgba(3,155,115,0.08)]'>
              <span className='text-[#039B73] font-bold text-xs'>Autopay</span>
              <Icon
                name='refreshDouble'
                className='text-[#039B73] h-4 w-4'
                strokeWidth={0.5}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

